export default __webpack_public_path__ + "static/media/plus.0f5f9bf8.svg";